import React from "react";
import eSputnik from "../../../eSputnik";
import Modal from "../../Modal";

// reservDateEnd: "20.10.2022"
// reservNumber: "1551149153"
// size: "18"
// storeName: "Kyiv city, Akademika Glushkova Ave., 13B, shopping center Magela"
export default function ReserveSuccess({ reservationDetail }) {
  const { phrases = {} } = window;
  const { reservDateEnd, reservNumber, size, storeName } = reservationDetail

  return (
    <Modal
      modalView="xs"
      title={phrases.product?.["book_modal_success"]?.title || "Reserved"}
      cssModifyer="reserve-success"
    >
      <div className="form-content">
        <div className="form-cont-row">
          <img src="/images/shield_success.svg" alt="img" />
          <p>
            {phrases.product?.["book_modal_success"]?.["reserve_number"] ||
              "Reserve number"}
            &nbsp;<span>{reservNumber}</span>
          </p>
        </div>
        {size && (
          <div className="form-cont-row">
            <img src="/images/dimension.svg" alt="img" />
            <p>
              {phrases.product?.["book_modal_success"]?.["product_size"] ||
                "Product size"}
              &nbsp;<span>{size}</span>
            </p>
          </div>
        )}
        <div className="form-cont-row">
          <img src="/images/clock.svg" alt="img" />
          <p
            dangerouslySetInnerHTML={{
              __html:
                phrases.product?.["book_modal_success"]?.[
                  "reserved_until"
                ].replace(":date", `<span>${reservDateEnd}</span>`) ||
                `Reserved until including <span>${reservDateEnd}</span>`,
            }}
          />
        </div>
        <div className="form-cont-row">
          <img src="/images/map_marker.svg" alt="img" />
          <p>{storeName}</p>
        </div>
        <button className="wb-btn btn-yellow js-close">
          {phrases.general?.close || "Close"}
        </button>
      </div>
    </Modal>
  );
}
